import { observer } from 'mobx-react-lite';
import { FaCarSide, FaShuttleVan } from 'react-icons/fa';
import { Header, Step } from 'semantic-ui-react';
import { IsActiveTab, IsDisableTab, IsCompleteTab } from '../../../app/common/util/util';
import { useStore } from '../../../app/stores/store';

interface Props {
    fluid: boolean,
    attached: boolean | "bottom" | "top" | undefined,
    currentTab: number,
    permitTypeId: number
}

export default observer(function StepMenuGroup({ 
    fluid, 
    attached, 
    currentTab,
    permitTypeId
 }: Props) {
    const {permitStore} = useStore();
    const {clickStep} = permitStore;
    
    return (
        <>
            <Header 
                attached
                as='h1'
                color='teal' 
                block
            >
                {permitTypeId === 2 ? (
                    <>
                        <FaCarSide className='custom-icon inline' />
                        <Header.Content>Apply Carpool Permit</Header.Content>
                    </>
                ) : ( 
                    <>
                        <FaShuttleVan className='custom-icon inline' />
                        <Header.Content>Apply Vanpool Permit</Header.Content>
                    </>
                )}
            </Header>
            <Step.Group fluid={fluid} attached={attached} stackable='tablet'>
            {/* <Step.Group vertical> */}
                <Step 
                    active={IsActiveTab(currentTab, 1)} 
                    completed={IsCompleteTab(currentTab, 1)}
                    disabled={IsDisableTab(currentTab, 1)}
                    icon='clipboard list' // columns, compass
                    link
                    onClick={() => clickStep(1)}
                    title='Step 1'
                    // description='Select Route / Terminal'
                />

                <Step 
                    active={IsActiveTab(currentTab, 2)} 
                    completed={IsCompleteTab(currentTab, 2)}
                    disabled={IsDisableTab(currentTab, 2)}
                    icon='calendar'
                    link
                    onClick={() => clickStep(2)}
                    title='Step 2'
                    // description='Weekly Sailing Schedule'
                />
                
                <Step 
                    active={IsActiveTab(currentTab, 3)} 
                    completed={IsCompleteTab(currentTab, 3)}
                    disabled={IsDisableTab(currentTab, 3)}
                    icon='user'
                    link
                    onClick={() => clickStep(3)}
                    title='Step 3'
                    // description='Enter billing information'
                />
                <Step 
                    active={IsActiveTab(currentTab, 4)} 
                    completed={IsCompleteTab(currentTab, 4)}
                    disabled={IsDisableTab(currentTab, 4)}
                    icon='car'
                    link
                    onClick={() => clickStep(4)}
                    title='Step 4'
                    // description='Enter billing information'
                />
                <Step 
                    active={IsActiveTab(currentTab, 5)} 
                    completed={IsCompleteTab(currentTab, 5)}
                    disabled={IsDisableTab(currentTab, 5)}
                    icon='users'
                    link
                    onClick={() => clickStep(5)}
                    title='Step 5'
                    // description='Enter billing information'
                />
                <Step 
                    active={IsActiveTab(currentTab, 6)} 
                    completed={IsCompleteTab(currentTab, 6)}
                    disabled={IsDisableTab(currentTab, 6)}
                    icon='info'
                    link
                    onClick={() => clickStep(6)}
                    title='Step 6'
                    // description='Enter billing information'
                />
            </Step.Group>
        </>
    )
})